export const addClassOver = (id) => {
    document.getElementById(id)?.classList?.add('over');
};
